import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Guarantee() {
  return <section className="w-full bg-navy-mid px-5 py-12 sm:py-20" data-id="element-82" data-mp="223eltma3nb3z">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto flex max-w-2xl flex-col items-center rounded-2xl border border-gold/45 bg-navy p-8 text-center sm:p-12" data-id="element-83" data-mp="222wk4a4o44oo">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-gold/15 text-gold" data-id="element-84" data-mp="1j52co0j6u18e">
          <ShieldCheckIcon className="h-9 w-9" aria-hidden="true" data-id="element-85" data-mp="1edc0rq4lr5ev" />
        </span>
        <h2 className="mt-5 font-display text-2xl font-bold text-white sm:text-3xl" data-id="element-86" data-mp="qnzq0ltmmpag">
          14-day money-back guarantee
        </h2>
        <p className="mt-2 text-sm font-medium text-gold sm:text-base" data-id="element-87" data-mp="lo4x6cqajpmr">
          Your investment is fully protected.
        </p>
        <div className="mt-6 space-y-4 text-sm leading-relaxed text-white/75 sm:text-base" data-id="element-88" data-mp="oxfac9teapsk">
          <p data-id="element-89" data-mp="twrxkvo6hyvo">
            Get full access to the complete system, review all 6 volumes and 4 bonuses, use them in
            your classes and see for yourself if it transforms how you teach.
          </p>
          <p data-id="element-90" data-mp="12t0v24slinf6">
            If, within the first 14 days, you decide the system is not right for you, we will refund
            100% of your purchase. No questions asked. No complicated process. No unnecessary
            back-and-forth.
          </p>
          <p className="font-semibold italic text-white" data-id="element-91" data-mp="f12h1d1ridyc">
            Explore the complete system risk-free. The decision is yours.
          </p>
        </div>
        <div className="mt-8 w-full max-w-md" data-id="element-92" data-mp="jy2dcw8t82c9">
          <CTAButton label="YES, I WANT THE COMPLETE SYSTEM" data-id="element-93" data-mp="1qfh4dasilwqe" />
          <p className="mt-3 text-xs text-white/60 sm:text-sm" data-id="element-94" data-mp="1vfll91xc4th5">14-day guarantee included.</p>
        </div>
      </motion.div>
    </section>;
}